import { render, staticRenderFns } from "./HotelsModal.vue?vue&type=template&id=2be7b238&scoped=true&"
import script from "./HotelsModal.vue?vue&type=script&lang=ts&"
export * from "./HotelsModal.vue?vue&type=script&lang=ts&"
import style0 from "./HotelsModal.vue?vue&type=style&index=0&id=2be7b238&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be7b238",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2be7b238')) {
      api.createRecord('2be7b238', component.options)
    } else {
      api.reload('2be7b238', component.options)
    }
    module.hot.accept("./HotelsModal.vue?vue&type=template&id=2be7b238&scoped=true&", function () {
      api.rerender('2be7b238', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "module/SearchBar/view/vue/HotelsModal.vue"
export default component.exports